import {Component, OnInit, AfterViewInit, Inject} from '@angular/core';
import {BaseComponent} from "../../../components/base/base.component";
import {AuthenticationService} from "../../../services/authenticate.service";
import {autoLogout} from "../../../modules/auth/state/auth.actions";
import {AuthState} from "../../../modules/auth/state/auth.state";
import {Store} from '@ngrx/store';
import {TranslateService} from '@ngx-translate/core';
import {debounceTime} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {environment} from 'src/environments/environment';
import {MatDialog} from '@angular/material/dialog';
import {AdminUserProfileComponent} from 'src/app/modules/admin/components/user/dialogs/profile/profile.component';
import {GlobalsService} from "../../../services/globals.service";
import * as _ from 'lodash';
import {FormControl} from '@angular/forms';
import {DOCUMENT} from '@angular/common';
import {RuleCheckerService} from "../../../services/rule-checker.service";

@Component({
    selector: 'app-layout-partial-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})

export class LayoutPartialHeaderComponent extends BaseComponent implements OnInit, AfterViewInit {
    pageSize = 50;
    pageIndex = 1;
    keyword = '';
    locationRef = environment.baseHref;
    imageSrc = this.globalsService.user.avatar.default;
    userInfo: any;
    linkGuideDoc = this.globalsService.user.guideDoc;
    windowHeight = 0;
    searchKeyword = new FormControl('');
    listApp = this.config.listApp;

    elem: any;
    fullScreen: boolean = false;
    
    constructor(public override authenticationService: AuthenticationService,
                public override activatedRoute: ActivatedRoute,
                public override translate: TranslateService,
                private readonly globalsService: GlobalsService,
                public ruleCheckerService: RuleCheckerService,
                public route: Router,
                public dialog: MatDialog,
                @Inject(DOCUMENT) private readonly document: any,
                private readonly store: Store<AuthState>) {
        super(authenticationService, activatedRoute, translate);
        this.userInfo = this.currentUser;
        this.imageSrc = this.userInfo?.avatar ?? this.imageSrc;
        this.elem = document.documentElement;
    }
    
    override ngOnInit() {
        super.ngOnInit();

        this.search();
        this.changeValueForm();
    }
    
    ngAfterViewInit() {
        setTimeout(() => {
            this.autoContentHeight();
            this.resizeWindow();
        }, 300);
    }
    
    logout() {
        this.store.dispatch(autoLogout());
    }
    
    switchOriginalUser = () => {
        const dataOriginalUser = this.authenticationService.getUserOriginalFromLocalStorage();
        this.authenticationService.setUserSwitchInLocalStorage(dataOriginalUser);
        this.authenticationService.removeUserOriginal();
        window.location.href = this.locationRef;
    }
    
    openProfile() {
        const dialogRef = this.dialog.open(AdminUserProfileComponent, {
            autoFocus: false,
            panelClass: 'app-profile',
            id: 'app-profile',
            width: '380px',
            maxHeight: '90vh',
        });
        dialogRef.afterClosed().subscribe(result => {
            this.currentUser = this.authenticationService.getUserFromLocalStorage();
            this.imageSrc = this.currentUser?.avatar ?? this.imageSrc;
        });
    }
    
    openLinkGuideDoc() {
        window.open(this.linkGuideDoc, '_blank');
    }
    
    autoContentHeight() {
        const footer = $('#footer').innerHeight() ?? 0;
        const header = $('#header').innerHeight() ?? 0;
        this.windowHeight = window.innerHeight;
        $('.content-inner').css({
            height: this.windowHeight ? this.windowHeight - header : '100vh',
            'padding-bottom': footer
        });
    }
    
    changeValueForm() {
        this.searchKeyword.valueChanges.subscribe(value => {
            this.keyword = value ?? '';
        });
    }
    
    search() {
        this.searchKeyword.valueChanges.pipe(debounceTime(500))
            .subscribe((value: any) => {
                if (value.length >= 3) {
                    this.onSearchData(value);
                } else {
                    this.clearResults();
                }
            })
    }
    
    onSearchData(value: string) {
        let queries: any = {
            keyword: value,
            siteLoading: false
        }
        
        queries = _.pickBy(queries, (value) => value !== undefined && value !== null && value !== '');

        // this.audienceService.get(queries).subscribe((result) => {
        //     if (result.status === 1) {
        //         this.audiences = result.data.audiences.length > 0 ? result.data.audiences : [];
        //     } else {
        //         this.clearResults();
        //     }
        // })

    }
    
    navigateToDetailAudience(id: number) {
        this.route.navigateByUrl('/', {skipLocationChange: true}).then(() => {
            this.searchKeyword.setValue('');
            this.route.navigate(['/audience/detail', id]);
        });
    }

    navigateToAllAudience(keyword: any) {
        this.route.navigateByUrl('/', {skipLocationChange: true}).then(() => {
            this.searchKeyword.setValue('');
            this.route.navigate(['/audience/list'], {queryParams: {keyword: keyword}});
        });
    }
    
    clearResults() {
        // this.audiences = [];
    }
    
    resizeWindow() {
        window.addEventListener('resize', this.autoContentHeight);
    }

    openFullscreen() {
        if (!this.fullScreen) {
            this.fullScreen = true;
            if (this.elem.requestFullscreen) {
                this.elem.requestFullscreen();
            } else if (this.elem.mozRequestFullScreen) {
                this.elem.mozRequestFullScreen();
            } else if (this.elem.webkitRequestFullscreen) {
                this.elem.webkitRequestFullscreen();
            } else if (this.elem.msRequestFullscreen) {
                this.elem.msRequestFullscreen();
            }
            return;
        }
        this.closeFullscreen();
    }

    private closeFullscreen() {
        this.fullScreen = false;
        if (this.document.fullscreenElement) {
            // @ts-ignore
            if (this.document.exitFullscreen()) {
                this.document.exitFullscreen();
            } else if (this.document.mozCancelFullScreen) {
                this.document.mozCancelFullScreen();
            } else if (this.document.webkitExitFullscreen) {
                this.document.webkitExitFullscreen();
            } else if (this.document.msExitFullscreen) {
                this.document.msExitFullscreen();
            }
        }

        this.openFullscreen();
    }
}
